import React from 'react';
import PropTypes from 'prop-types';

function FormSectionHeading({
  className,
  label,
}) {
  return (
    <div className={className}>
      <h5 className="FormSectionHeading">
        {label}
      </h5>
    </div>
  );
}

FormSectionHeading.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
};

FormSectionHeading.defaultProps = {
  className: undefined,
  label: undefined,
};

export default FormSectionHeading;



// WEBPACK FOOTER //
// ./src/components/Forms/Fields/FormSectionHeading.js